var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"placeholder":_vm.plc || 'Партнёр клиника',"filterable":"","clearable":""},on:{"input":_vm.dispatch},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},_vm._l((_vm.clinics),function(item){return _c('el-option',{key:'clinic_'+item.id,attrs:{"label":item.name,"value":item.id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }